<<template>
  <div></div>
</template>

<script>
export default {
  name: 'vuecomponent',
  data () {
    return {
      key: "value"
    }
  },
  methods: {
    func () {

    }
  },
}
</script>

<style lang="scss" scoped>
</style>
